import {NodeSelection, TextSelection} from 'prosemirror-state';

import {
  chainCommands,
  deleteSelection,
  joinForward,
  selectNodeForward,
} from 'prosemirror-commands';
import {imageWrapper} from '../../Common/imageWrapper';

import 'fomantic-ui-less/definitions/modules/modal';
import 'fomantic-ui-less/definitions/modules/dimmer';
import {escapeHtml} from '../../Common/escapeHtml';

export default class ContainerCodeNodeView {
    constructor(name, node, view, getPos) {
        this.name = name;
        this.view = view;
        this.getPos = getPos;
        this.node = node;

        this.dom = this.createDom();
        this.dom.id = `${name}-${getPos()}`;

        this.viewDom = this.createDom();
        this.viewDom.id = `view-${name}-${getPos()}`;
        this.viewDom.classList.add(name);
        this.viewDom.addEventListener("click", () => this.handleClick());

        this.dom.appendChild(this.viewDom);

        this.renderView();
    }

    get editorMode() {
        return "";
    }

    createDom() {
        return document.createElement('div');
    }

    renderView(codeText = this.node.textContent, debounced = false) {
        if (!codeText || codeText.length === 0) {
            this.replaceDomInnerHTML('');
            return;
        }

        if (debounced) {
            this.rendererDebounced(codeText);
        } else {
            this.renderer(codeText);
        }
    }

    renderer(codeText) {
        this.replaceDomInnerHTML(`<pre><code>${codeText ? escapeHtml(codeText) : ''}</code></pre>`);
    }

    rendererDebounced(codeText) {
        this.renderer(codeText);
    }

    replaceDomInnerHTML(innerHTML, dom = this.viewDom, name = this.name) {
        if (!innerHTML || innerHTML.length === 0) {
            dom.classList.add(`empty-${name}-node`);
        } else {
            dom.classList.remove(`empty-${name}-node`);
        }

        if (innerHTML instanceof HTMLElement) {
            if (dom.firstChild) {
                dom.replaceChild(innerHTML, dom.firstChild);
            } else {
                dom.appendChild(innerHTML);
            }
        } else {
            dom.innerHTML = innerHTML;
        }
    }

    wrapImage(imageHtml) {
        return imageWrapper(imageHtml);
    }

    importAdditionalChunks() {
    }

    selectNode() {
        if (!this.view.editable) {
            return;
        }

        this.viewDom.classList.add(`selected-${this.name}`);

        if (this.editorDom) {
            return;
        }

        const editorContentDom = document.createElement('div');
        editorContentDom.className = 'ui active centered inline loader';

        this.editorDom = document.createElement('div');
        this.editorDom.id = `editor-${this.name}-${this.getPos()}`;
        this.editorDom.className = 'ui raised segments transition hidden';
        this.editorDom.appendChild(editorContentDom);

        const {bottom: viewBottom} = this.viewDom.getBoundingClientRect();
        const {bottom: boxBottom} = this.view.dom.getBoundingClientRect();
        this.editorDom.style.top = 8 + viewBottom - boxBottom + "px";
        this.editorDom.style.backgroundColor = '#fff';

        this.view.dom.parentNode.appendChild(this.editorDom);

        $(this.editorDom).transition({
            animation: 'scale',
            duration: 0
        });

        const {from: replaceStart, to: replaceEnd} = this.view.state.selection;

        this.importAdditionalChunks();
        import(/* webpackChunkName: "code-editor" */ "codemirror/addon/selection/active-line");
        import(/* webpackChunkName: "code-editor" */ "codemirror/addon/edit/matchbrackets");
        import(/* webpackChunkName: "code-editor" */ "codemirror/lib/codemirror.css");
        import(/* webpackChunkName: "code-editor" */ "codemirror/theme/idea.css");
        import(/* webpackChunkName: "code-editor" */ "codemirror/lib/codemirror").then(module => {
        const CodeMirror = module.default;
        const codeMirror = new CodeMirror(null, {
          value: this.tempContent || this.node.textContent,
          lineNumbers: true,
          styleActiveLine: {nonEmpty: true},
          viewportMargin: Infinity,
          theme: 'idea'
        });
        codeMirror.setCursor(codeMirror.lineCount(), 0);
        codeMirror.on('change', cm => {
          this.tempContent = cm.getValue();
          this.renderView(cm.getValue(), true);
        });
        codeMirror.setOption('mode', this.editorMode);
        codeMirror.on('cursorActivity', () => {
          if (!this.view.editable) {
            codeMirror.setOption("readOnly", 'nocursor');
          }
        });

        const saveText = newCodeText => {
          delete this.tempContent;
          const textNode = newCodeText ? this.view.state.schema.text(newCodeText) : null;
          let node = this.node.type.create(null, textNode);
          this.view.dispatch(this.view.state.tr.replaceWith(replaceStart, replaceEnd, node));
          this.view.focus();
        }

        const closeEditor = () => {
          delete this.tempContent;
          const $pos = this.view.state.doc.resolve(this.getPos());
          const transaction = this.view.state.tr.setSelection(TextSelection.near($pos));
          this.view.dispatch(transaction);
          this.view.focus();
        }

        const okButton = document.createElement('button');
        okButton.id = `ok-${this.dom.id}`;
        okButton.className = 'ui tiny compact button primary';
        okButton.textContent = 'Save';
        okButton.addEventListener("click", () => {
          const newCodeText = codeMirror.getValue() || '';

          if (this.node.textContent.trim() === newCodeText.trim()) {
            closeEditor();
            return;
          }

          saveText(newCodeText);
        });

        const cancelButton = document.createElement('button');
        cancelButton.id = `cancel-${this.dom.id}`;
        cancelButton.className = 'ui tiny compact button';
        cancelButton.textContent = 'Cancel';
        cancelButton.addEventListener("click", closeEditor);

        const removeButton = document.createElement('button');
        removeButton.id = `remove-${this.dom.id}`;
        removeButton.className = 'ui tiny compact button';
        removeButton.textContent = 'Remove';
        removeButton.addEventListener("click", () => {
          delete this.tempContent;
          chainCommands(deleteSelection, joinForward, selectNodeForward)(this.view.state, this.view.dispatch);
          this.view.focus();
        });

        const editorSegment = codeMirror.getWrapperElement();
        editorSegment.classList.add('ui', 'segment');

        editorContentDom.replaceWith(editorSegment);

        const buttonsGroup = document.createElement('div');
        buttonsGroup.className = 'ui wrapping spaced buttons';
        buttonsGroup.appendChild(okButton);
        buttonsGroup.appendChild(document.createTextNode('\u00A0'));
        buttonsGroup.appendChild(cancelButton);
        buttonsGroup.appendChild(document.createTextNode('\u00A0'));
        buttonsGroup.appendChild(removeButton);

        const buttonsSegment = document.createElement('div');
        buttonsSegment.className = 'ui secondary segment';
        buttonsSegment.appendChild(buttonsGroup);
        buttonsSegment.insertAdjacentHTML('beforeend', '<div id="render-loader" class="ui tiny inline loader"></div>')

        this.editorDom.appendChild(buttonsSegment);

        if (this.viewDom instanceof HTMLSpanElement) {
          codeMirror.getScrollerElement().style.minHeight = '100px';
        } else {
          codeMirror.getScrollerElement().style.minHeight = '400px';
        }

        setTimeout(() => {
          codeMirror.refresh();
          codeMirror.focus();
        }, 100)
      }).catch(() => {
        if (this.editorDom) {
          this.editorDom.innerHTML = '<div class="ui message error visible">Unable to load editor, please try again.</div>';
        }
      });
    }

    deselectNode() {
        if (!this.view.editable) {
            return;
        }

        this.viewDom.classList.remove(`selected-${this.name}`);

        this.renderView();

        if (this.editorDom) {
            this.editorDom.remove();
            delete this.editorDom;
        }
    }

    ignoreMutation() {
        return true;
    }

    handleClick() {
        if (!this.view.editable) {
            return;
        }

        const $pos = this.view.state.doc.resolve(this.getPos());
        const transaction = this.view.state.tr.setSelection(new NodeSelection($pos));
        this.view.dispatch(transaction);
    }

    stopEvent(e) {
      if (/key/.test(e.type)) {
        return true;
      } else if (this.view.editable && this.editorDom && /drag/.test(e.type)) {
        this.editorDom.remove();
        delete this.editorDom;
      }
    }

    destroy() {
        delete this.tempContent;
        this.deselectNode();
        this.dom.remove();
        delete this.dom;
    }
}